import {
  STATISTICS_LIST,
  STATISTICS_LIST_FAIL,
  STATISTICS_TODAY_VS_YESTERDAY_LIST,
  STATISTICS_TODAY_VS_YESTERDAY_LIST_FAIL,
  STATISTICS_WITHIN15MIN_LIST,
  STATISTICS_WITHIN15MIN_LIST_FAIL,
  STATISTICS_WEEKLY_LIST,
  STATISTICS_WEEKLY_LIST_FAIL,
  STATISTICS_ITEMS_PER_MINUTE_LIST,
  STATISTICS_ITEMS_PER_MINUTE_LIST_FAIL,
  STATISTICS_ITEMS_PER_HOUR_LIST,
  STATISTICS_ITEMS_PER_HOUR_LIST_FAIL,
  STATISTICS_SCAN_SCORE_LIST,
  STATISTICS_SCAN_SCORE_LIST_FAIL,
  PRODUCTION_GOAL,
  PRODUCTION_GOAL_FAIL,
  SCAN_SCORE_UPDATE
} from '../constants';

const initialState = {
  listDaily: [],
  todayVsYesterdayList: [],
  withIn15MinList: [],
  weeklyList: [],
  itemsPerMinuteList: [],
  itemsPerHourList: [],
  scanScoreDailyList: [],
  scanScoreList: {},
  productionGoal: {}
};

const statisticsReducer = (state = initialState, action) => {
  switch (action.type) {
    case STATISTICS_LIST:
      return {...state, listDaily: action.payload};
    case STATISTICS_LIST_FAIL:
      return {...state, listDaily: action.payload};
    case STATISTICS_TODAY_VS_YESTERDAY_LIST:
      return {...state, todayVsYesterdayList: action.payload};
    case STATISTICS_TODAY_VS_YESTERDAY_LIST_FAIL:
      return {...state, todayVsYesterdayList: action.payload};
    case STATISTICS_WITHIN15MIN_LIST:
      return {...state, withIn15MinList: action.payload};
    case STATISTICS_WITHIN15MIN_LIST_FAIL:
      return {...state, withIn15MinList: action.payload};
    case STATISTICS_WEEKLY_LIST:
      return {...state, weeklyList: action.payload};
    case STATISTICS_WEEKLY_LIST_FAIL:
      return {...state, weeklyList: action.payload};
    case STATISTICS_ITEMS_PER_MINUTE_LIST:
      return {...state, itemsPerMinuteList: action.payload};
    case STATISTICS_ITEMS_PER_MINUTE_LIST_FAIL:
      return {...state, itemsPerMinuteList: action.payload};
    case STATISTICS_ITEMS_PER_HOUR_LIST:
      return {...state, itemsPerHourList: action.payload};
    case STATISTICS_ITEMS_PER_HOUR_LIST_FAIL:
      return {...state, itemsPerHourList: action.payload};
    case STATISTICS_SCAN_SCORE_LIST:
      return {...state, scanScoreDailyList: action.payload};
    case STATISTICS_SCAN_SCORE_LIST_FAIL:
      return {...state, scanScoreDailyList: action.payload};
    case PRODUCTION_GOAL:
      return {...state, productionGoal: action.payload};
    case PRODUCTION_GOAL_FAIL:
      return {...state, productionGoal: action.payload};
    case SCAN_SCORE_UPDATE: {
      const userKey = action.payload.user_id || action.payload.packing_user_id || action.payload.user_name;
      return {
        ...state,
        scanScoreList: {
          ...state.scanScoreList,
          [userKey]: {
            userId: action.payload.user_id || action.payload.packing_user_id,
            name: action.payload.user_name,
            score: action.payload.score
          }
        }
      };
    }
    default:
      return state;
  }
};

export default statisticsReducer;
